export default __webpack_public_path__ + "static/media/993.58328feb.svg";